<template>
<!-- 手机行业解决方案 -->
    <section class="solution pet-solution">
        <div class="layout-banner">
            <div class="banner_box"></div>
            <div class="banner">
                <div class="banner-text w-1200">
                    <div class="big-text">宠物行业解决方案</div>
                    <div class="sm-text">PET INDUSTRY SOLUTIONS</div>
                    <!-- <div class="line"></div> -->
                </div>
            </div>
            <Nav :activeIndex='"2-2"'></Nav>
        </div>
        <div class="solution-content">
            <p class="applications-title">宠物行业解决方案</p>
            <p class="subhead">PET INDUSTRY SOLUTIONS</p>
            <div class="solution-context">
                <div class="w-1200">
                    <div class="title">行业痛点</div>
                    <div class="desc">
                        <el-row>
                            <el-col :span="6">宠物保险产品方案无竞争力、推广难，或是杠杆低、性价比不高，或是病种限制多等，宠物主购买意愿低</el-col>
                            <el-col :span="6" :offset="3">投保、理赔流程繁琐，宠物唯一性识别难，芯片、虹膜等识别方案不友好</el-col>
                            <el-col :span="6" :offset="3">费用居高不下、保险核赔难度大，无法判断诊疗手段及费用真实性、合理性</el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="solution-scene">
                <div class="w-1200">
                    <div class="title">主流场景</div>
                    <div class="desc">
                        <ul class="clearfix">
                            <div class="tabs-bar" :style="`transform: translate3d(${tabsBarleft}px, 0px, 0px);`"></div>
                            <li :style="`left:${index*225}px`" v-for="(item, index) in allSceneList" :key="index" :class="[index===activeScene?'active':'']" @click="sceneClick(index)">{{item.name}}</li>
                        </ul>
                        <div class="scene-row">
                            <div class="scene-col">
                                <img src="../../assets/solution/jjfa_10.jpg" alt="">
                                <div class="scene-right">
                                    <h6>方案概要</h6>
                                    <div class="text">{{allSceneList[activeScene].outline}}</div>
                                </div>
                            </div>
                            <div class="scene-col">
                                <img src="../../assets/solution/jjfa_11.jpg" alt="">
                                <div class="scene-right">
                                    <h6>核心能力</h6>
                                    <div class="text">{{allSceneList[activeScene].ability}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <img :src="require(`../../assets/solution/icon${item}.png`)" alt="" v-for="item in 8" :key="item" :class="`icon${item}`">
            </div>
            <div class="solution-feature">
                <div class="w-1200">
                    <div class="title">能力模组</div>
                    <div class="desc">
                        <div class="left-top">
                            <div class="sub-title">宠物智能识别：</div>
                            <div>鼻纹+面部双重认证，只需视觉刷脸+刷鼻纹，即可实现身份认证，线上全流程完成投保、理赔</div>
                        </div>
                        <div class="left-bottom">
                            <div class="sub-title">全国服务网络：</div>
                            <div>宠物服务网络3000+服务网点，覆盖全国，总对总合作、网格化管理</div>
                        </div>
                        <div class="right-top">
                            <div class="sub-title">顶级专家团队：</div>
                            <div>20+知名宠物专家团队，平均医疗经验超过10年，覆盖全科，逐案审计、精细管控</div>
                        </div>
                        <div class="right-bottom">
                            <div class="sub-title">智能中台系统：</div>
                            <div>涵盖移动零售系统、智能核保、智能理赔、智慧经营分析等各模块，实现宠物保险线上化、数据化、智能化经营</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="solution-customer">
                <div class="w-1200">
                    <div class="title">合作客户</div>
                    <div class="desc">
                        <div class="customer"><img src="../../assets/partners/phone/partners2.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners3.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners10.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners8.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners5.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners11.jpg" alt=""></div>
                        <div class="customer"><img src="../../assets/partners/phone/partners9.jpg" alt=""></div>
                        <div class="itemempty"></div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
        <Cornerbar></Cornerbar>
    </section>
</template>

<script>
import Nav from '@/components/Nav'
import Footer from '@/components/Footer'
import Cornerbar from '@/components/Cornerbar'
export default {
  components: {
    Nav,
    Footer,
    Cornerbar
  },
  data () {
    return {
      tabsBarleft: 0,
      activeScene: 0,
      allSceneList: [{ name: '线下宠物生活服务门店', outline: '前端赋能一整套移动端销售工具，打通客户端、销售端、运营端、承保端，一键销售、全程风控、轻松服务', ability: '一整套宠物医疗服务产品零售解决方案，合作伙伴“零”开发，支持T+0上线' },
        { name: '品牌宠物集团线上商城', outline: '结合线上商城客群特点，定制宠物医疗、宠物责任、疫苗等一整套人+宠物的产品方案及增值服务，促进客群线上转化', ability: '多家保险公司系统对接，产品+服务方案快速定制、上线' }
      ]
    }
  },
  methods: {
    sceneClick (index) {
      this.activeScene = index
      this.tabsBarleft = index * 225
    }
  }
}

</script>
<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/variable.scss";
.pet-solution{
    .banner_box{
        background-image: url(../../assets/banner1.png);
    }
    .solution-content{
        .solution-context{
            margin: 40px 0 60px 0;
            .desc{
                width: 100%;
                margin-top: 30px;
                font-size: 14px;
                color: #666;
                line-height: 2;
                .el-col{
                    padding:30px 26px;
                    height: 144px;
                    box-shadow:0px 2px 18px rgba(3, 123, 255, 0.1);
                    text-align: center;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                    img{
                        width: 60px;
                        height: 60px;
                    }
                    &:hover{
                        transform: translateY(-3px);
                        box-shadow: 0px 2px 18px rgba(3, 123, 255, 0.1);
                        transition: box-shadow .3s, border .3s, background-color .3s, color .3s, transform .3s;
                    }
                }
            }
        }
        .solution-scene{
            .desc{
                ul{
                    width: 450px;
                    .tabs-bar{
                        width: 225px;
                    }
                    li{
                        width: 225px;
                    }
                }
            }
        }
        .solution-feature{
            background-color:#f5faff;
            padding-top: 40px;
            .desc{
                background-image: url(../../assets/solution/solution2.png);
                background-repeat: no-repeat;
                background-position: 50% 50%;
                height: 550px;
                width: 100%;
                position: relative;
                font-size: 14px;
                color: #666666;
                &>div{
                    position: absolute;
                    height: 71px;
                    width: 263px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    .sub-title {
                        font-weight: 500;
                        // font-family: PingFangSC-Medium;
                        color: #333;
                    }
                }
                .left-top{
                    left: 52px;
                    top: 130px;
                }
                .left-bottom{
                    left: 52px;
                    top: 310px;
                }
                .right-top{
                    right: 52px;
                    top: 133px;
                }
                .right-bottom{
                    right: 52px;
                    top: 308px;
                }
            }
        }
    }
}
</style>
